import * as types from './types';

export const initialize = ({ dispatch, rootGetters }) => {
  const _package = rootGetters['simulation/getActivePackage'];
  const activePackageConfig = rootGetters['packages/getActivePackageConfig'];

  const hideModules = [
    'fatura_detalhe'
  ];

  if (activePackageConfig.simulationType !== 'msaPosPago' && activePackageConfig.simulationType !== 'PartnersPostPaid') {
    hideModules.push('movel_adicionais');
  }

  const items = [];

  if (!activePackageConfig.features.disablePackageStartPage) {
    items.push({
      name: 'Início',
      handle: 'inicio',
      navigatable: false,
      display: true
    });
  }

  Object.keys(_package).forEach((moduleName) => {
    if (!moduleName.startsWith('_')) {
      const $module = _package[moduleName];

      items.push({
        name: $module.meta.title,
        handle: moduleName,
        navigatable: true,
        display: !hideModules.includes(moduleName)
      });

      if ($module.children && !$module.config.childrenNotNavigatable) {
        Object.keys($module.children).forEach((childName) => {
          items.push({
            name: $module.meta.title,
            handle: childName,
            navigatable: true,
            display: false
          });
        });
      }
    }
  });

  items.push({
    name: 'Concluir',
    handle: 'concluir',
    navigatable: false,
    display: true
  });

  dispatch('setNavigation', items);
};

export const setBlocked = ({ commit }, payload) => {
  commit(types.SET_BLOCKED, payload);
};

export const setCurrent = ({ commit }, payload) => {
  commit(types.SET_CURRENT, payload);
};

export const setNavigation = ({ commit }, payload) => {
  commit(types.SET_NAVIGATION, payload);
};

export const setVisibility = ({ commit }, payload) => {
  commit(types.SET_VISIBILITY, payload);
};

export default {
  initialize,
  setBlocked,
  setCurrent,
  setNavigation,
  setVisibility
};



// WEBPACK FOOTER //
// ./src/store/modules/timeline/actions.js